import React from 'react'
import { Col, Row } from 'react-bootstrap'
import imgApp from '../resourses/app-image.jpg'
import tick from '../resourses/tick.png'

const DownloadApp = props => {
    const [imgContainer, setImageContainer] = React.useState({
        backgroundImage: props.width >= 991 ? `url(${imgApp})` : "",
        backgroundPositionX: "0",
        backgroundPositionY: "50%",
        backgroundSize: "cover"
    })

    React.useEffect(() => {
        if (props.width <= 991) {
            setImageContainer({})
        } else {
            setImageContainer({
                backgroundImage: `url(${imgApp})`,
                backgroundPositionX: "0",
                backgroundPositionY: "50%",
                backgroundSize: "cover"
            })
        }
    }, [props.width])

    const listStyle = {
        listStyleImage: `url(${tick})`
    }

    return (
        <div className="mt-5 mb-5">
            <Row style={imgContainer}>
                <Col md={6} sm={0}></Col>
                <Col md={6} className="p-5 col-app d-flex flex-column">
                    <h4 className="greenblue">CEREALNET</h4>
                    <h4 className="greenblue">
                        A través de nuestra App cada cliente puede visualizar:
                    </h4>
                    <ul className="list-home mt-4" style={listStyle}>
                        <li>Posición del día.</li>
                        <li>Detalle de carta de porte buscada.</li>
                        <li>Búsqueda histórica por número de carta o por patente.</li>
                        <li>Solicitar llamado al entregador.</li>
                        <li>Notificaciones push y notificaciones por mail.</li>
                    </ul>
                    <div className="d-flex justify-content-end">
                        <button
                            style={{ border: "solid 1px #0E3C39", borderRadius: "0px", color: "#0E3C39" }}
                            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.cerealnet.android&hl=es_419&gl=US", "_blank")}
                            className="btn btn-light mt-4 px-5"
                        >
                            {">"} Descarga la app
                        </button>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default DownloadApp